/* plantas finas — setzt die Zahlungslogos unter den Kaufbutton.

   Warum per JavaScript: Der Kaufbutton liegt in Dawns sections/main-product.liquid.
   Würden wir dort eingreifen, wäre die Änderung beim nächsten Dawn-Update weg.
   Stattdessen liefert snippets/pf-payicons.liquid ein <template> mit den
   offiziellen Grafiken, das hier nur noch an die richtige Stelle gehängt wird. */
(function () {
  function setzen() {
    var vorlage = document.getElementById('pf-payicons');
    if (!vorlage) return;

    var ziele = document.querySelectorAll('.product-form__buttons');
    Array.prototype.forEach.call(ziele, function (ziel) {
      if (ziel.querySelector('.pf-payrow')) return;
      ziel.appendChild(vorlage.content.cloneNode(true));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setzen);
  } else {
    setzen();
  }

  /* Dawn zeichnet den Kaufbereich bei Variantenwechsel neu — dann erneut setzen. */
  document.addEventListener('change', function () { setTimeout(setzen, 60); });
})();
